module.exports = __webpack_public_path__ + "static/media/complete.1a55cdbb.svg";